import React from 'react';
import classnames from 'classnames';
import { bindToContent } from 'client/data/models/cms';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { AppraisalUserTestimonials } from 'site-modules/shared/components/appraisal-user-testimonials/appraisal-user-testimonials';

export const stateToPropsConfig = {
  testimonials: bindToContent('editorial/includes/carmax/testimonials', 'testimonials'),
};

const AppraisalReportUserTestimonialsUI = connectToModel(AppraisalUserTestimonials, stateToPropsConfig);

export const AppraisalReportUserTestimonials = ({ className, ...props }) => (
  <AppraisalReportUserTestimonialsUI
    className={classnames('appraisal-report-step-user-testimonials', className)}
    subheading="Join thousands of happy customers who redeemed an offer using Edmunds."
    {...props}
  />
);
